<template>
    <div class="message">
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
    .message
        height: 70%
</style>



// WEBPACK FOOTER //
// src/components/message/message.vue